import logo from './logo.svg';
import './App.css';
import Warehouse from "./components/Warehouse";
import {Warehouse2} from "./components/Warehouse2";

function App() {
  return (
    <div className="App">
      <header className="App-header">
          <p>Automatic Chaotic Warehouse simulator</p>
      </header>
        <div>
            <Warehouse2/>
        </div>
    </div>
  );
}

export default App;
